import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

// Stock is counted in whole units (12 bags, 40 kg), so quantities are shown and typed without decimals.

export const wholeOnly = (raw) => String(raw ?? "").replace(/\D/g, "");

export const fmtQty = (value) =>
  value === null || value === undefined || value === "" ? "—" : Math.round(Number(value)).toLocaleString("en-IN");

export function UnitTag({ unit, className }) {
  return (
    <span className={cn("inline-block rounded bg-secondary px-1.5 py-0.5 text-[11px] font-medium uppercase text-muted-foreground", className)}>
      {unit || "—"}
    </span>
  );
}

export function QtyWithUnit({ qty, unit, className, testId }) {
  return (
    <span className={cn("inline-flex items-center justify-end gap-1.5", className)} data-testid={testId}>
      <span className="font-mono">{fmtQty(qty)}</span>
      <UnitTag unit={unit} />
    </span>
  );
}

/** A whole-number quantity box. onChange gets the cleaned string (digits only), not the event. Pass `unit` to show it beside the box. */
export function QtyInput({ value, onChange, unit, className, wrapperClassName, ...props }) {
  const blockKey = (e) => {
    if (e.key.length === 1 && !/[0-9]/.test(e.key) && !e.ctrlKey && !e.metaKey) e.preventDefault();
  };
  const box = (
    <Input
      {...props}
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      autoComplete="off"
      title="Whole numbers only"
      value={value ?? ""}
      onKeyDown={blockKey}
      onChange={(e) => onChange(wholeOnly(e.target.value))}
      className={className}
    />
  );
  if (unit === undefined) return box;
  return (
    <div className={cn("flex items-center gap-1.5", wrapperClassName)}>
      {box}
      <UnitTag unit={unit} className="shrink-0" />
    </div>
  );
}
